
import React from 'react';
import { Instagram } from 'lucide-react';

const Footer: React.FC = () => {
  return (
    <footer className="bg-brand-black text-white pt-20 pb-12">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12 mb-20">
          <div className="md:col-span-2">
            <h2 className="font-serif text-3xl mb-8">Khamal Bags</h2>
            <p className="text-gray-400 max-w-sm font-light leading-relaxed mb-8">
              Restez connectés. Suivez-nous sur nos réseaux sociaux pour découvrir nos nouveaux arrivages et toute l'actualité de la marque.
            </p>
            <div className="flex space-x-6 mb-8">
              <a href="https://www.instagram.com/khamal.bags/$0" target="_blank" rel="noreferrer" className="hover:text-brand-gold luxury-transition">
                <Instagram size={20} />
              </a>
              <a href="https://www.tiktok.com/@khamal.bags" target="_blank" rel="noreferrer" className="hover:text-brand-gold luxury-transition">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                  <path d="M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .8.11V9.4a6.33 6.33 0 0 0-1-.08A6.34 6.34 0 0 0 3 15.66a6.34 6.34 0 0 0 10.86 4.43 6.34 6.34 0 0 0 3.14-5.42V8.23a8.16 8.16 0 0 0 4.59 1.48V6.26a4.86 4.86 0 0 1-2-.45z"/>
                </svg>
              </a>
            </div>
          </div>

          <div>
            <h4 className="text-[11px] uppercase tracking-[0.3em] font-bold mb-8 text-brand-gold">
              Navigation
            </h4>
            <ul className="space-y-4 text-sm font-light text-gray-400">
              <li><Link to="/shop" className="hover:text-white transition-colors">Boutique</Link></li>
              <li><Link to="/" className="hover:text-white transition-colors">Notre Histoire</Link></li>
              <li><Link to="/admin" className="hover:text-white transition-colors">Espace Admin</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-[11px] uppercase tracking-[0.3em] font-bold mb-8 text-brand-gold">
              Contactez nous
            </h4>
            <ul className="space-y-4 text-sm font-light text-gray-400">
              <li><a href="https://wa.me/221788984561" target="_blank" rel="noreferrer" className="hover:text-white transition-colors">WhatsApp</a></li>
              <li><a href="mailto:contact@khamal.store?subject=Demande d'information - Khamal Bags" className="hover:text-white transition-colors">Mail</a></li>
           
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-gray-800 flex flex-col md:flex-row justify-between items-center text-[10px] text-gray-500 uppercase tracking-[0.2em]">
          <p>© 2026 Khamal Bags. Tous droits réservés.</p>
          <div className="flex space-x-8 mt-4 md:mt-0">
          
          </div>
        </div>
      </div>
    </footer>
  );
};
import { Link } from 'react-router-dom';
export default Footer;
